import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';
import { CalcNetPanel, Row, UnitInput, FeetInches, RadioGroup, ResultTable } from '../_fitnessHelpers';

export default function HealthyWeightCalc() {
  const [tab, setTab] = useState(0);
  const [age, setAge] = useState(30);
  const [gender, setGender] = useState('male');
  const [ft, setFt] = useState(5);
  const [inches, setInches] = useState(10);
  const [cm, setCm] = useState(178);
  const clear = () => { setAge(30); setGender('male'); setFt(5); setInches(10); setCm(178); };
  const c = useMemo(() => {
    const h = tab === 0 ? ((+ft||0)*12+(+inches||0))*0.0254 : (+cm||0)/100;
    const min = 18.5*h*h, max = 24.9*h*h;
    const disp = k => tab === 0 ? `${(k/0.453592).toFixed(1)} lb` : `${k.toFixed(1)} kg`;
    return { min, max, h, disp };
  }, [tab, ft, inches, cm]);

  return (
    <CalcShell look="cnet" title="Healthy Weight Calculator" subtitle="Find the healthy weight range (BMI 18.5 – 24.9) for a given height.">
      <CalcNetPanel slug="hw" activeTab={tab} onTabChange={setTab} onClear={clear} right={
        <div>
          <div className="text-lg text-slate-800">Healthy weight range</div>
          <div className="text-2xl font-bold text-[#2f9c3f]" data-testid="hw-range">{c.disp(c.min)} – {c.disp(c.max)}</div>
          <ResultTable testid="hw-info-table" rows={[
            ['Corresponds to BMI', '18.5 – 24.9'],
            ['Height (m)', c.h.toFixed(3)],
          ]}/>
          <div className="mt-4 p-3 bg-blue-50 rounded text-xs text-slate-700">
            <b>BMI Categories</b>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-1">
              <span>&lt; 18.5</span><span>Underweight</span>
              <span>18.5 – 24.9</span><span className="font-semibold text-green-700">Healthy weight</span>
              <span>25.0 – 29.9</span><span>Overweight</span>
              <span>≥ 30.0</span><span>Obesity</span>
            </div>
          </div>
        </div>
      }>
        <Row label="Age"><UnitInput value={age} onChange={setAge} testid="hw-age"/></Row>
        <Row label="Gender"><RadioGroup name="hw-g" value={gender} onChange={setGender} options={[{value:'male',label:'male'},{value:'female',label:'female'}]}/></Row>
        {tab === 0
          ? <Row label="Height"><div className="grid grid-cols-2 gap-2 flex-1"><FeetInches ft={ft} inches={inches} onFt={setFt} onIn={setInches} testidPrefix="hw-h"/></div></Row>
          : <Row label="Height"><UnitInput value={cm} onChange={setCm} unit="cm" testid="hw-hcm"/></Row>}
      </CalcNetPanel>
    </CalcShell>
  );
}
